/**
 * Installed-tools rows are aggregated server-side by `(toolId, category)`
 * (see backend `listInstalledToolsDataTable`), so `toolId` alone is not unique —
 * one tool can surface as multiple rows differing only by category. Use the
 * composite as the stable row id for expansion/highlight.
 */
export function getInstalledToolRowId(row: {
  toolId: string;
  category: string;
}): string {
  return `${row.toolId}::${row.category}`;
}
